// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.KA8uNoNyBeusQzcedS8N {
	margin: 0 5px !important;
}
.aZUhHsnNadWuZgh4KPHA {
	min-width: 400px;
}
.GZZ1lTtVTcz5r8nRZfZ8 {
	display: flex;
	justify-content: center;
}
`, "",{"version":3,"sources":["webpack://./src/shared/components/shared.css"],"names":[],"mappings":"AAAA;CACC,wBAAwB;AACzB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,aAAa;CACb,uBAAuB;AACxB","sourcesContent":[".confirmActionBtns {\r\n\tmargin: 0 5px !important;\r\n}\r\n.confirmActionModalBox {\r\n\tmin-width: 400px;\r\n}\r\n.confirmActionButtonsGroup {\r\n\tdisplay: flex;\r\n\tjustify-content: center;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"confirmActionBtns": `KA8uNoNyBeusQzcedS8N`,
	"confirmActionModalBox": `aZUhHsnNadWuZgh4KPHA`,
	"confirmActionButtonsGroup": `GZZ1lTtVTcz5r8nRZfZ8`
};
export default ___CSS_LOADER_EXPORT___;
